export enum IWorkingSessionsAnalyticsActivityEnum {
  LocalSessionStart = 'WorkingSessionsAnalyticsActivity.local_session_start',
  FocusPercentage = 'WorkingSessionsAnalyticsActivity.focusPercentage',
  DigitalIntensity = 'WorkingSessionsAnalyticsActivity.digitalIntensity',
  TotalSessionDuration = 'WorkingSessionsAnalyticsActivity.totalDuration',
  TotalActivityDuration = 'WorkingSessionsAnalyticsActivity.totalActivityDuration',
  TotalFocusDuration = 'WorkingSessionsAnalyticsActivity.totalFocusDuration',
  TotalSessionCallDuration = 'WorkingSessionsAnalyticsActivity.totalSessionCallDuration',
  UserId = 'WorkingSessionsAnalyticsActivity.userid',
  CumulativeDailyAverageScreentime = 'WorkingSessionsAnalyticsActivity.cumulativeDailyAverageScreentime',
  CumulativeDailyAverageWorkingHours = 'WorkingSessionsAnalyticsActivity.cumulativeDailyAverageWorkingHours',
  CumulativeWeeklyAverageScreentime = 'WorkingSessionsAnalyticsActivity.cumulativeDailyAverageScreentime',
  CumulativeWeeklyAverageWorkingHours = 'WorkingSessionsAnalyticsActivity.cumulativeDailyAverageWorkingHours',
  WeekCount = 'WorkingSessionsAnalyticsActivity.weekCount',
  DayCount = 'WorkingSessionsAnalyticsActivity.dayCount',
}

export enum IWorkingSessionsAnalyticsActivityScoresEnum {
  FocusPercentage = 'WorkingSessionsAnalyticsActivity.focusPercentage',
  DigitalIntensity = 'WorkingSessionsAnalyticsActivity.digitalIntensity',
  TotalSessionDuration = 'WorkingSessionsAnalyticsActivity.totalDuration',
  TotalActivityDuration = 'WorkingSessionsAnalyticsActivity.totalActivityDuration',
  TotalSessionCallDuration = 'WorkingSessionsAnalyticsActivity.totalSessionCallDuration',
}

export enum IWorkingSessionsAnalyticsActivityEnumV2 {
    LocalSessionStart = 'WorkingSessionsAnalyticsActivityV2.local_session_start',
    FocusPercentage = 'WorkingSessionsAnalyticsActivityV2.focusPercentage',
    DigitalIntensity = 'WorkingSessionsAnalyticsActivityV2.digitalIntensity',
    SessionCallDuration = 'WorkingSessionsAnalyticsActivityV2.sessionCallDuration',
    TotalSessionDuration = 'WorkingSessionsAnalyticsActivityV2.totalDuration',
    TotalActivityDuration = 'WorkingSessionsAnalyticsActivityV2.totalActivityDuration',
    TotalFocusDuration = 'WorkingSessionsAnalyticsActivityV2.totalFocusDuration',
    TotalSessionCallDuration = 'WorkingSessionsAnalyticsActivityV2.totalSessionCallDuration',
    UserId = 'WorkingSessionsAnalyticsActivityV2.userid',
    CumulativeDailyAverageScreentime = "WorkingSessionsAnalyticsActivityV2.cumulativeDailyAverageScreentime",
    CumulativeDailyAverageWorkingHours = "WorkingSessionsAnalyticsActivityV2.cumulativeDailyAverageWorkingHours",
    CumulativeWeeklyAverageScreentime = "WorkingSessionsAnalyticsActivityV2.cumulativeDailyAverageScreentime",
    CumulativeWeeklyAverageWorkingHours = "WorkingSessionsAnalyticsActivityV2.cumulativeDailyAverageWorkingHours",
    WeekCount = "WorkingSessionsAnalyticsActivityV2.weekCount",
    DayCount = "WorkingSessionsAnalyticsActivityV2.dayCount",
    CallWeekCount = "WorkingSessionsAnalyticsActivityV2.callWeekCount",
    CallDayCount = "WorkingSessionsAnalyticsActivityV2.callDayCount",
    WeekDayIndex = "WorkingSessionsAnalyticsActivityV2.weekday_index"
}

export enum IWorkingSessionsAnalyticsActivityScoresEnumV2 {
    FocusPercentage = 'WorkingSessionsAnalyticsActivityV2.focusPercentage',
    DigitalIntensity = 'WorkingSessionsAnalyticsActivityV2.digitalIntensity',
    TotalSessionDuration = 'WorkingSessionsAnalyticsActivityV2.totalDuration',
    TotalActivityDuration = 'WorkingSessionsAnalyticsActivityV2.totalActivityDuration',
    TotalSessionCallDuration = 'WorkingSessionsAnalyticsActivityV2.totalSessionCallDuration',
}
